import { SolarCalcPage } from '../NewVersion/components/solar-calculator';
import css from './index.module.scss';
import Progress from './components/progress';
import Step1 from './components/step1';
import Step2 from './components/step2';
import Step3 from './components/step3';
import Step4 from './components/step4';
import Step5 from './components/step5';
import { useGlobal } from '@/utils/useGlobal';

export default function SolarCalcH5() {
    const { useState } = useGlobal();
    const [calcObj, setCalcObj] = useState({
        currentStep: 0,
        currentPage: SolarCalcPage.Step1,
    });
    const handleCallBack = (obj: any, isPageChanged?: boolean) => {
        setCalcObj(obj);
        if (isPageChanged) {
            window.scrollTo({
                top: (window.innerWidth / 375) * 300,
                behavior: 'auto',
            });
        }
    };
    return (
        <div className={`solar-calculator ${css['solar-calculator']}`}>
            <Progress calcObj={calcObj} />
            <>
                {calcObj.currentPage === SolarCalcPage.Step1 && <Step1 calObj={calcObj} callBack={handleCallBack} />}
                {calcObj.currentPage === SolarCalcPage.Step2 && <Step2 calObj={calcObj} callBack={handleCallBack} />}
                {calcObj.currentPage === SolarCalcPage.Step3 && <Step3 calObj={calcObj} callBack={handleCallBack} />}
                {calcObj.currentPage === SolarCalcPage.Step4 && <Step4 calObj={calcObj} callBack={handleCallBack} />}
                {calcObj.currentPage === SolarCalcPage.Step5 && <Step5 calObj={calcObj} callBack={handleCallBack} />}
            </>
        </div>
    );
}
